function setAccessibeVerticalPosition(topOffset = '50%') {
  const widgets = document.querySelectorAll('access-widget-ui');

  if (!widgets) return;

  widgets.forEach((widgetEl) => {
    const widgetPosition = getComputedStyle(widgetEl).getPropertyValue('--offset-top');
    widgetEl.setAttribute('data-previous-position', widgetPosition);
    widgetEl.style.setProperty('--offset-top', topOffset);
  });
}

function revertAccessibeVerticalPosition() {
  const widgets = document.querySelectorAll('access-widget-ui');

  if (!widgets) return;

  widgets.forEach((widgetEl) => {
    const previousWidgetPosition = widgetEl.getAttribute(
      'data-previous-position',
    );

    if (!previousWidgetPosition) return;

    widgetEl.style.setProperty('--offset-top', previousWidgetPosition);
  });
}

function getCurrentAccessibeVerticalPosition() {
  const widgets = document.querySelectorAll('access-widget-ui');
  let position = null;

  if (!widgets) {
    return position;
  }

  widgets.forEach((widgetEl) => {
    const widgetPosition = getComputedStyle(widgetEl).getPropertyValue('--offset-top');

    if (!widgetPosition) return;

    position = widgetPosition;
  });

  return position;
}

function hideAccessibeButton() {
  setAccessibeVerticalPosition('99999px');
}

function showAccessibeButton() {
  revertAccessibeVerticalPosition();
}

export default {
  getCurrentAccessibeVerticalPosition,
  hideAccessibeButton,
  revertAccessibeVerticalPosition,
  setAccessibeVerticalPosition,
  showAccessibeButton,
};
